export default __webpack_public_path__ + "static/form-grouping-do-70d16f8aa50aca489ceeaaefa5e893be.png";